import React, { Component } from "react";
import Select from "react-select";
import moment from "moment";
import DatePicker from "react-datetime";
import { ToastContainer, toast } from "react-toastify";
import {
  main_url,
  getCookieData,
  calculationDate,
  validate,
  stopSaving,
  startSaving,
  calculationDate1,
} from "../../utils/CommonFunction";
import {
  leaveBalanceDetails,
  leaveAllowedFiscalYear,
} from "../../utils/apiRoutes";
import { getHeaders } from "../../utils/apiHelper";
import DateTimeService from "../../utils/dateTimeService";

var form_validate = true;
class LeaveManagementEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: this.props.tab,
      user_info: getCookieData("user_info"),
      data: props.data,
      employeeList: [],
      leaveCategory: [],
      verifyBy: [],
      approvedBy: [],
      selectedEmployee: [],
      selectedCategory: this.props.data.leave_category,
      selectedVerifyBy: [],
      selectedApproveBy: [],
      startDate: "",
      endDate: "",
      reason: this.props.data.reason,
      attachment: "",
      doc: [],
      isHR: "",
      leaveDetail: null,
      leave_days1: null,
      halfDay: this.props.data.leave_days,
      halfTime: this.props.data.half_time,
      showRadio: this.props.data.leave_days === 0.5 ? true : false,
      childDeliveryDate: "",
      holidays: 0,
      leaveBalanceDetails: [],
      leaveAllowedFiscalYear: undefined,
    };
  }

  componentDidMount() {
    this.getLeaveAllowedFiscalYear();
    fetch(`${main_url}leave/getHR`, {
      headers: getHeaders(),
    })
      .then((response) => response.json())
      .then((data) =>
        this.setState({
          isHR: data
            .map((v) => v.user_id)
            .find((v) => v === this.state.user_info.user_id),
        })
      );

    this.leaveCategory();
    fetch(`${main_url}leave/getLeave/${this.props.data.leave_application_id}`, {
      headers: getHeaders(),
    })
      .then((response) => response.json())
      .then((data) =>
        this.setState({
          doc: data[0].attachment,
          isVerify: data,
        })
      );

    fetch(`${main_url}leave/viewBerify/${this.state.data.verify_by}`, {
      headers: getHeaders(),
    })
      .then((response) => response.json())
      .then((data) => this.setState({ verifyBy: data[0].fullname }));

    fetch(`${main_url}leave/viewApproved/${this.state.data.approve_by}`, {
      headers: getHeaders(),
    })
      .then((response) => response.json())
      .then((data) =>
        data.length > 0
          ? this.setState({ approvedBy: data[0].fullname })
          : this.setState({ approvedBy: "" })
      );

    this.getLeaveBalanceDetails();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.data.approve_by_name != this.props.data.approve_by_name ||
      prevProps.data.verify_by_name != this.props.data.verify_by_name
    ) {
      this.setState({ approvedBy: this.props.data.approve_by_name });
      this.setState({ verifyBy: this.props.data.verify_by_name });
    }
  }

  get balanceBySelectedLeaveCategory() {
    if (this.state.leaveBalanceDetails.length === 0) return 0; // zero when there's no data yet
    const detail = this.state.leaveBalanceDetails.find(
      (detail) =>
        detail.leave_category_id ===
        parseInt(
          !this.state.selectedCategory.value
            ? this.props.data.leave_category_id
            : this.state.selectedCategory.value
        )
    );
    if (!detail) return 0; // Guard condition
    return detail.total - detail.taken;
  }

  isLeaveIgnoreFiscalYear(selectCategory) {  
    if (selectCategory || !Array.isArray(this.state.selectedCategory)) {
      const fiscalYearIgnoreLeaves = [3]; // Maternity Leave
      const fiscalYearIgnoreLeaveNames = ["Maternity Leave"];
      const IDfound = fiscalYearIgnoreLeaves.includes(
        selectCategory ?? this.state.selectedCategory.value,
      );
      // For editing leaves, this.state.selectedCategory can be the leave category NAME before user updates this field
      const nameFound = fiscalYearIgnoreLeaveNames.includes(
        selectCategory ?? this.state.selectedCategory
      );
      return IDfound || nameFound;
    }
  }

  /**
   * After earned leave carry calculation for latest fiscal year,
   * only allow new leave applications within this latest calculated fiscal year.
   * @param {object} date Moment Object
   * @returns {boolean} is allowed or not allowed
   */
  isLeaveAllowedForSelectedDate(date, selectCategory) {
    if (this.isLeaveIgnoreFiscalYear(selectCategory)) return true; // Certain leaves are allowed without fiscal year restrictions
    if (!this.state.leaveAllowedFiscalYear) return false; // better not allowed when there's no data yet

    const formatDate = new DateTimeService(date).formatDate;
    return new DateTimeService(formatDate).isDateWithin(
      this.state.leaveAllowedFiscalYear.startDate,
      this.state.leaveAllowedFiscalYear.endDate
    );
  }

  checkFiscalYearMargins(startDate, endDate) {
    const start = new Date(new DateTimeService(startDate).formatDate);
    const end = new Date(new DateTimeService(endDate).formatDate);

    const startYear = start.getFullYear();
    const endYear = end.getFullYear();
    const startMonth = start.getMonth() + 1;
    const endMonth = end.getMonth() + 1;

    if (startYear === endYear && startMonth === 3 && endMonth === 4) {
      return true;
    }
    return false;
  }

  getVerifyBy() {
    let user_id = 0;
    let category_id = 0;
    user_id = this.state.user_info.user_id;

    var category = this.state.selectedCategory;
    category_id = !Array.isArray(category) ? category.value : 0;
    fetch(`${main_url}leave/getVerifyBy/${user_id}/${category_id}`, {
      headers: getHeaders(),
    })
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((res) => {
        this.setState({ verifyBy: res });
      })
      .catch((error) => console.error(`Fetch Error =\n`, error));
  }

  getApprovedBy() {
    let user_id = 0;
    let category_id = 0;
    user_id = this.state.user_info.user_id;
    var category = this.state.selectedCategory;
    category_id = !Array.isArray(category) ? category.value : 0;
    fetch(`${main_url}leave/getApprovedBy/${user_id}/${category_id}`, {
      headers: getHeaders(),
    })
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((res) => {
        this.setState({ approvedBy: res });
      })
      .catch((error) => console.error(`Fetch Error =\n`, error));
  }

  async getHolidays(startDate, endDate) {
    try {
      const url =
        main_url +
        `leave/getHolidays/${moment(startDate).format("YYYY-MM-DD")}/${moment(
          endDate,
        ).format("YYYY-MM-DD")}`;
      const response = await fetch(url, {
        headers: getHeaders(),
      });

      if (!response.ok) {
        throw new Error(`Couldn't fetch holidays data!`);
      }
      const data = await response.json();
      let holidays = data.reduce(
        (previousValue, currentValue) =>
          previousValue + (currentValue.holidays + 1),
        0,
      );
      this.setState({
        holidays: holidays,
      });
    } catch (_) {
      this.setState({
        holidays: 0,
      });
    }
  }

  async getLeaveBalanceDetails() {
    const res = await fetch(leaveBalanceDetails, {
      method: "post",
      headers: getHeaders(false),
      body: JSON.stringify({
        userIds: [this.state.data.user_id],
        leaveCategories: [],
      }),
    });
    if (!res.ok) {
      return toast.error("Error: Could not get leave balance details!");
    }
    const { data } = await res.json();
    this.setState({ leaveBalanceDetails: data });
  }

  async getLeaveAllowedFiscalYear() {
    const res = await fetch(leaveAllowedFiscalYear, {
      headers: getHeaders(false),
    });
    if (!res.ok) {
      return toast.error("Error: Something went wrong.");
    }
    const { data } = await res.json();
    this.setState({
      leaveAllowedFiscalYear: {
        startDate: data.startDate,
        endDate: data.endDate,
      },
    });
  }

  getEmployeeList() {
    fetch(`${main_url}main/getEmployeeWithDesignation/0`, {
      headers: getHeaders(),
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          employeeList: data,
        });
      });
  }

  leaveCategory() {
    fetch(main_url + "leave/getLeaveCategory", {
      headers: getHeaders(),
    })
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((res) => {
        // res.pop();
        if (this.props.data.approved_date == null) {
          this.setState({ leaveCategory: res.filter((v) => v.value != 11) });
        } else {
          if (this.props.data.approve_by == this.state.user_info.user_id) {
            res = res.filter(function (l) {
              return l.label == "Casual Leave" || l.label == "Earned Leave";
            });
            this.setState({
              leaveCategory: res.filter((v) => v.value != 11),
            });
          } else {
            this.setState({ leaveCategory: res.filter((v) => v.value != 11) });
          }
        }
      })
      .catch((error) => console.error(`Fetch Error =\n`, error));
  }

  handleChangeCategory = (e) => {
    // If earned leave carry calculation is finished for next fiscal year,
    // we can only take new leaves for this latest calculated fiscal year.
    // So, better set the selected date to next fiscal year start.
    const defaultDate = new DateTimeService(
      this.state.leaveAllowedFiscalYear.startDate
    ).normalized;
    if (
      !this.isLeaveAllowedForSelectedDate(this.state.startDate, e.value) ||
      !this.isLeaveAllowedForSelectedDate(this.state.endDate, e.value)
    ) {
      this.setState({
        startDate: defaultDate,
        endDate: defaultDate,
      });
      this.setState(
        {
          startDate: defaultDate,
          endDate: defaultDate,
        },
        async () => {
          await this.getHolidays(
            this.state.startDate,
            this.state.endDate == ""
              ? this.props.data.leave_end_date
              : this.state.endDate
          );
          this.leaveDays(
            this.state.startDate,
            this.state.endDate == ""
              ? this.props.data.leave_end_date
              : this.state.endDate
          );
        }
      );
    }
    // ___________________________________________________________________________________________

    this.setState(
      {
        selectedCategory: e,
      },
      () => {
        this.getVerifyBy();
        this.getApprovedBy();
      }
    );
  };

  handleChangeEmployee = (e) => {
    this.setState(
      {
        selectedEmployee: e,
      },
      () => {
        this.getVerifyBy();
        this.getApprovedBy();
      }
    );
  };

  handleChangeVerifyBy = (e) => {
    this.setState({
      selectedVerifyBy: e,
    });
  };

  handleChangeApproveBy = (e) => {
    this.setState({
      selectedApproveBy: e,
    });
  };

  handleChangeChildDeliveryDate = (event) => {
    this.setState({
      childDeliveryDate: event,
    });
  };

  handleChangeStartDate = (event) => {
    if (!this.isLeaveAllowedForSelectedDate(event)) {
      if (
        this.checkFiscalYearMargins(
          event,
          this.state.endDate == ""
            ? this.props.data.leave_end_date
            : this.state.endDate
        )
      ) {
        return toast.error(
          "HRMS စနစ်စည်းမျဥ်းအရ မတ်လနှင့် ဧပြီလကို ခွင့်တစောင်တည်းပေါင်းတင်၍မရပါ။ ခွင့်၂စောင်ဖြင့် ခွဲတင်ပါရန်။"
        );
      }

      return toast.error(
        "New leaves cannot be applied for in that fiscal year."
      );
    }

    this.setState(
      {
        startDate: event,
      },
      async () => {
        await this.getHolidays(
          this.state.startDate,
          this.state.endDate == ""
            ? this.props.data.leave_end_date
            : this.state.endDate
        );
        this.leaveDays(
          this.state.startDate,
          this.state.endDate == ""
            ? this.props.data.leave_end_date
            : this.state.endDate
        );
      }
    );
  };

  handleChangeEndDate = (event) => {
    if (!this.isLeaveAllowedForSelectedDate(event)) {
      if (
        this.checkFiscalYearMargins(
          this.state.startDate == ""
            ? this.props.data.leave_start_date
            : this.state.startDate,
          event
        )
      ) {
        return toast.error(
          "HRMS စနစ်စည်းမျဥ်းအရ မတ်လနှင့် ဧပြီလကို ခွင့်တစောင်တည်းပေါင်းတင်၍မရပါ။ ခွင့်၂စောင်ဖြင့် ခွဲတင်ပါရန်။"
        );
      }

      return toast.error(
        "New leaves cannot be applied for in that fiscal year."
      );
    }

    this.setState(
      {
        endDate: event,
      },
      async () => {
        await this.getHolidays(
          this.state.startDate == ""
            ? this.props.data.leave_start_date
            : this.state.startDate,
          this.state.endDate
        );
        this.leaveDays(
          this.state.startDate == ""
            ? this.props.data.leave_start_date
            : this.state.startDate,
          this.state.endDate
        );
      }
    );
  };

  handleChangeReason = (e) => {
    if (e.target.value != "") {
      this.setState({
        reason: e.target.value,
        buttonState: false,
      });
    } else {
      this.setState({
        reason: null,
      });
    }
  };

  handleChangeComment = (e) => {
    this.setState({
      comments: e.target.value,
    });
  };

  handleChangeAttachment = (e) => {
    this.setState({
      selectedEmployee: e,
    });
  };

  onChangeWork(event) {
    const data = event.target.value;
    if (data === "0.5" || data === "AM" || data === "PM") {
      this.setState({
        halfDay: data,
        showRadio: true,
        halfTime: "AM",
      });
      return;
    }
    this.setState({
      halfDay: data,
      showRadio: false,
      halfTime: "",
    });
    this.setState({
      halfDay: event.target.value,
    });
  }

  onChangeRadio(event) {
    this.setState({ halfTime: event.target.value });
  }

  leaveDays(startDate, endDate) {
    if (
      this.state.selectedCategory.value == undefined
        ? this.props.data.leave_category_id == 4
        : this.state.selectedCategory.value == 4
    ) {
      this.setState({
        leave_days1:
          calculationDate1(startDate, endDate) - parseInt(this.state.holidays),
      });
    } else {
      this.setState({
        leave_days1:
          calculationDate1(startDate, endDate) - parseInt(this.state.holidays) > 5
            ? calculationDate(startDate, endDate)
            : calculationDate1(startDate, endDate) -
              parseInt(this.state.holidays),
      });
    }
  }

  checkFiles = (e) => {
    var files = document.getElementById("attach_file").files;
    var attachment = [];
    for (let i = 0; i < files.length; i++) {
      attachment.push(files[i]);
    }

    this.setState({
      attachment: attachment,
    });
  };

  removeOldDocument(event) {
    this.setState({
      doc: null,
    });
  }

  verifySave() {
    // let path = `updateLeave`;
    let user_id = 0;

    if (validate("check_form")) {
      if (this.state.tab === 1) {
        user_id = this.state.user_info.user_id;
      } else {
        var user = this.state.selectedEmployee;
        user_id = !Array.isArray(user) ? user.value : 0;
      }
      let leave_days = calculationDate(
        this.state.startDate,
        this.state.endDate
      );
      let data = {
        application_status: 2,
        leave_category_id:
          this.state.selectedCategory.value == undefined
            ? this.props.data.leave_category_id
            : this.state.selectedCategory.value,
        comments: this.state.comments,
        req_days: parseFloat(this.state.data.leave_days),
        max_days: this.balanceBySelectedLeaveCategory,
        verify_date: new Date(),
        leave_start_date:
          this.state.startDate == ""
            ? this.props.data.leave_start_date
            : moment(this.state.startDate).format("YYYY-MM-DD"),
        leave_end_date:
          this.state.endDate == ""
            ? this.props.data.leave_start_date
            : moment(this.state.endDate).format("YYYY-MM-DD"),
      };

      const formdata = new FormData();

      formdata.append("leave_info", JSON.stringify(data));
      let status = 0;
      fetch(
        `${main_url}leave/updateLeave/` + this.state.data.leave_application_id,
        {
          method: "POST",
          headers: getHeaders(),
          body: formdata,
        }
      )
        .then((res) => {
          status = res.status;
          return res.text();
        })
        .then((text) => {
          if (status === 200) {
            toast.success(text);
            window.location.reload();
          } else toast.error(text);
        });
    } else {
      startSaving();
      form_validate = false;
    }
  }

  approvedSave() {
    // let path = `updateLeave`;
    let user_id = 0;

    if (validate("check_form")) {
      if (this.state.tab === 1) {
        user_id = this.state.user_info.user_id;
      } else {
        var user = this.state.selectedEmployee;
        user_id = !Array.isArray(user) ? user.value : 0;
      }
      let data = {
        application_status: 3,
        leave_category_id:
          this.state.selectedCategory.value == undefined
            ? this.props.data.leave_category_id
            : this.state.selectedCategory.value,
        comments: this.state.comments,
        req_days: parseFloat(this.state.data.leave_days),
        max_days: this.balanceBySelectedLeaveCategory,
        approve_date: new Date(),
        leave_start_date:
          this.state.startDate == ""
            ? this.props.data.leave_start_date
            : moment(this.state.startDate).format("YYYY-MM-DD"),
        leave_end_date:
          this.state.endDate == ""
            ? this.props.data.leave_start_date
            : moment(this.state.endDate).format("YYYY-MM-DD"),
      };

      const formdata = new FormData();

      formdata.append("leave_info", JSON.stringify(data));
      let status = 0;
      fetch(
        `${main_url}leave/updateLeave/` + this.state.data.leave_application_id,
        {
          method: "POST",
          headers: getHeaders(),
          body: formdata,
        }
      )
        .then((res) => {
          status = res.status;
          return res.text();
        })
        .then((text) => {
          if (status === 200) {
            toast.success(text);
            window.location.reload();
          } else toast.error(text);
        });
    } else {
      startSaving();
      form_validate = false;
    }
  }

  rejectSave() {
    // let path = `updateLeave`;
    let user_id = 0;

    if (validate("check_form")) {
      if (this.state.tab === 1) {
        user_id = this.state.user_info.user_id;
      } else {
        var user = this.state.selectedEmployee;
        user_id = !Array.isArray(user) ? user.value : 0;
      }
      let data = {
        application_status: 4,
        leave_category_id: this.state.selectedCategory.value,
        comments: this.state.comments,
        req_days: parseFloat(this.state.data.leave_days),
        max_days: this.balanceBySelectedLeaveCategory,
      };

      const formdata = new FormData();

      formdata.append("leave_info", JSON.stringify(data));
      let status = 0;
      fetch(
        `${main_url}leave/updateLeave/` + this.state.data.leave_application_id,
        {
          method: "POST",
          headers: getHeaders(),
          body: formdata,
        }
      )
        .then((res) => {
          status = res.status;
          return res.text();
        })
        .then((text) => {
          if (status === 200) {
            toast.success(text);
            window.location.reload();
          } else toast.error(text);
        });
    } else {
      startSaving();
      form_validate = false;
    }
  }

  referBackSave() {
    // let path = `updateLeave`;
    let user_id = 0;

    if (validate("check_form")) {
      if (this.state.tab === 1) {
        user_id = this.state.user_info.user_id;
      } else {
        var user = this.state.selectedEmployee;
        user_id = !Array.isArray(user) ? user.value : 0;
      }
      let data = {
        application_status: 5,
        leave_category_id: this.state.selectedCategory.value,
        comments: this.state.comments,
        req_days: parseFloat(this.state.data.leave_days),
        max_days: this.balanceBySelectedLeaveCategory,
        referback_date: new Date(),

        leave_start_date:
          this.state.startDate == ""
            ? this.props.data.leave_start_date
            : moment(this.state.startDate).format("YYYY-MM-DD"),
        leave_end_date:
          this.state.endDate == ""
            ? this.props.data.leave_start_date
            : moment(this.state.endDate).format("YYYY-MM-DD"),
      };

      const formdata = new FormData();

      formdata.append("leave_info", JSON.stringify(data));
      let status = 0;
      fetch(
        `${main_url}leave/updateLeave/` + this.state.data.leave_application_id,
        {
          method: "POST",
          headers: getHeaders(),
          body: formdata,
        }
      )
        .then((res) => {
          status = res.status;
          return res.text();
        })
        .then((text) => {
          if (status === 200) {
            toast.success(text);
            window.location.reload();
          } else toast.error(text);
        });
    } else {
      startSaving();
      form_validate = false;
    }
  }

  disableAction() {
    if (
      this.state.data.user_id == this.state.user_info.user_id &&
      (this.state.startDate != ""
        ? moment.utc(this.state.startDate).format("YYYY-MM-DD") ==
          moment.utc(this.state.endDate).format("YYYY-MM-DD")
        : this.props.data.leave_start_date == this.props.data.leave_end_date)
    ) {
      return false;
    }
    return true;
  }

  save() {
    let user_id = 0;

    if (validate("check_form")) {
      let leave_days =
        calculationDate1(
          this.state.startDate == ""
            ? this.props.data.leave_start_date
            : this.state.startDate,
          this.state.endDate == ""
            ? this.props.data.leave_end_date
            : this.state.endDate
        ) > 5 && this.state.selectedCategory.value != 4
          ? calculationDate(
              this.state.startDate == ""
                ? this.props.data.leave_start_date
                : this.state.startDate,
              this.state.endDate == ""
                ? this.props.data.leave_end_date
                : this.state.endDate
            )
          : calculationDate1(
              this.state.startDate == ""
                ? this.props.data.leave_start_date
                : this.state.startDate,
              this.state.endDate == ""
                ? this.props.data.leave_end_date
                : this.state.endDate
            );

      let data = {
        application_status: 1,
        child_delivery_date:
          this.state.childDeliveryDate == ""
            ? this.props.data.child_delivery_date
            : moment(this.state.childDeliveryDate).format("YYYY-MM-DD"),
        leave_start_date:
          this.state.startDate == ""
            ? this.props.data.leave_start_date
            : moment(this.state.startDate).format("YYYY-MM-DD"),
        leave_end_date:
          this.state.endDate == ""
            ? this.props.data.leave_end_date
            : moment(this.state.endDate).format("YYYY-MM-DD"),
        leave_category_id:
          this.state.selectedCategory.value == undefined
            ? this.props.data.leave_category_id
            : this.state.selectedCategory.value,
        leave_days:
          leave_days == 1 || leave_days == 0
            ? this.state.halfDay
            : this.state.leave_days1 == null
            ? parseFloat(this.props.data.leave_days)
            : this.state.leave_days1 == 0
            ? this.state.halfDay
            : this.state.leave_days1,
        half_time: this.state.halfTime,
        reason:
          this.state.reason == "" ? this.state.data.reason : this.state.reason,
        verifyBy:
          this.state.selectedVerifyBy.length == 0
            ? this.state.data.verifyBy
            : this.state.selectedVerifyBy.value,
        approvedBy:
          this.state.selectedApproveBy.length == 0
            ? this.state.data.approve_by
            : this.state.selectedApproveBy.value,
        files: imagedata,
        max_days: this.balanceBySelectedLeaveCategory,
        comments: this.state.comments,
        doc: this.state.doc,
        apply_date: this.props.data.application_date,
      };
      const formdata = new FormData();
      var obj = document.querySelector("#attach_file").files.length;
      for (var i = 0; i < obj; i++) {
        var imagedata = document.querySelector("#attach_file").files[i];
        formdata.append("uploadfile", imagedata);
      }
      formdata.append("leave_info", JSON.stringify(data));
      let status = 0;
      fetch(
        `${main_url}leave/updateLeave/` + this.state.data.leave_application_id,
        {
          method: "POST",
          headers: getHeaders(),
          body: formdata,
        }
      )
        .then((res) => {
          status = res.status;
          return res.text();
        })
        .then((text) => {
          if (status === 200) {
            toast.success(text);
            window.location.reload();
          } else toast.error(text);
        });
    } else {
      startSaving();
      form_validate = false;
    }
  }

  render() {
    return (
      <div
        className="nl"
        style={{
          display: "flex",
          justifyContent: "center",
          height: "500px",
          overflowY: "scroll",
        }}
      >
        <div className="col-sm-12 white-bg mt20">
          <div
            className="bg-primary"
            style={{ padding: "5px", marginBottom: "20px" }}
          >
            <p style={{ fontSize: "20px", fontWeight: "bold" }}>
              Leave Request
            </p>
          </div>
          <div
            className="form-horizontal"
            id="check_form"
            style={{ marginTop: 17, paddingLeft: "20px", paddingRight: "20px" }}
          >
            <div className="form-group">
              <div>
                <label className="col-sm-4">
                  Employee Name<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-8">
                {
                  <input
                    type="text"
                    className="form-control"
                    value={this.props.data.fullname}
                    disabled
                  />
                }
              </div>
            </div>
            <div className="form-group">
              <div>
                <label className="col-sm-4">
                  Leave Category<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-8">
                {this.state.data.user_id == this.state.user_info.user_id ||
                this.props.data.application_status == 3 ? (
                  <Select
                    placeholder={this.props.data.leave_category}
                    options={this.state.leaveCategory}
                    value={this.state.selectedCategory}
                    // value={this.state.selectedCategory}
                    onChange={this.handleChangeCategory}
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                ) : (
                  <input
                    type="text"
                    className="form-control"
                    value={this.props.data.leave_category}
                    disabled
                  />
                )}
              </div>
            </div>
            <div className="form-group">
              <div>
                <label className="col-sm-4">
                  Leave Balance<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  value={
                    this.props.data.leave_category_id == 11
                      ? this.props.data.leave_days
                      : this.balanceBySelectedLeaveCategory
                  }
                  disabled
                ></input>
              </div>
            </div>
            <div className="form-group">
              <div>
                <label className="col-sm-4">
                  Verify By<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-8">
                {this.state.data.user_id == this.state.user_info.user_id ? (
                  <Select
                    placeholder={
                      typeof this.state.selectedCategory == "string"
                        ? this.state.verifyBy
                        : "Select Verify Person"
                    }
                    options={this.state.verifyBy}
                    value={
                      this.state.selectedVerifyBy.length == 0
                        ? this.state.verifyBy
                        : this.state.selectedVerifyBy
                    }
                    onChange={this.handleChangeVerifyBy}
                    className="react-select-container "
                    classNamePrefix="react-select"
                  />
                ) : (
                  <input
                    type="text"
                    className="form-control"
                    value={
                      this.state.data.application_status == 3
                        ? this.props.data.verify_by_name
                        : this.state.verifyBy
                    }
                    disabled
                  />
                )}
              </div>
            </div>
            <div className="form-group">
              <div>
                <label className="col-sm-4">
                  Approved By<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-8">
                {this.state.data.user_id == this.state.user_info.user_id ? (
                  <Select
                    placeholder={
                      typeof this.state.selectedCategory == "string"
                        ? this.state.approvedBy
                        : "Select Approve Person"
                    }
                    options={this.state.approvedBy}
                    value={
                      this.state.selectedApproveBy.length == 0
                        ? this.state.approvedBy
                        : this.state.selectedApproveBy
                    }
                    onChange={this.handleChangeApproveBy}
                    className="react-select-container "
                    classNamePrefix="react-select"
                  />
                ) : (
                  <input
                    type="text"
                    className="form-control"
                    value={
                      this.state.data.application_status == 3
                        ? this.props.data.approve_by_name
                        : this.state.approvedBy
                    }
                    disabled
                  />
                )}
              </div>
            </div>
            {this.props.data.leave_category_id == 4 ? (
              <div className="form-group">
                <div>
                  <label className="col-sm-4">
                    Child Delivery Date<span className="text-danger">*</span>
                  </label>{" "}
                </div>
                <div className="col-sm-8">
                  {this.state.data.user_id == this.state.user_info.user_id ? (
                    <DatePicker
                      className="checkValidate"
                      timeFormat={false}
                      value={
                        this.state.childDeliveryDate == ""
                          ? this.props.data.child_delivery_date
                          : this.state.childDeliveryDate
                      }
                      onChange={this.handleChangeChildDeliveryDate}
                    />
                  ) : (
                    <input
                      type="text"
                      className="form-control"
                      value={this.props.data.child_delivery_date}
                      disabled
                    />
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="form-group">
              <div>
                <label className="col-sm-4">
                  Start Date<span className="text-danger">*</span>
                </label>{" "}
              </div>
              <div className="col-sm-8">
                {this.state.data.user_id == this.state.user_info.user_id ? (
                  <DatePicker
                    className="checkValidate"
                    timeFormat={false}
                    value={
                      this.state.startDate == ""
                        ? this.props.data.leave_start_date
                        : this.state.startDate
                    }
                    onChange={this.handleChangeStartDate}
                  />
                ) : (
                  <input
                    type="text"
                    className="form-control"
                    value={this.props.data.leave_start_date}
                    disabled
                  />
                )}
              </div>
            </div>
            <div className="form-group">
              <div>
                <label className="col-sm-4">
                  End Date<span className="text-danger">*</span>
                </label>{" "}
              </div>
              <div className="col-sm-8 ">
                {this.state.data.user_id == this.state.user_info.user_id ? (
                  <DatePicker
                    className="checkValidate"
                    timeFormat={false}
                    value={
                      this.state.endDate == ""
                        ? this.props.data.leave_end_date
                        : this.state.endDate
                    }
                    onChange={this.handleChangeEndDate}
                  />
                ) : (
                  <input
                    type="text"
                    className="form-control"
                    value={this.props.data.leave_end_date}
                    disabled
                  />
                )}
              </div>
            </div>
            <div className="form-group">
              <div>
                <label className="col-sm-4">
                  Applied On<span className="text-danger">*</span>
                </label>{" "}
              </div>
              <div className="col-sm-8 ">
                <input
                  type="text"
                  className="form-control"
                  value={moment(this.props.data.application_date)
                    .utc()
                    .format("YYYY-MM-DD h:mm a")}
                  disabled
                />
              </div>
            </div>
            <div className="form-group">
              <div>
                <label className="col-sm-4">
                  Leave Days<span className="text-danger">*</span>
                </label>
              </div>
              <div className="col-sm-8">
                {this.state.data.user_id == this.state.user_info.user_id ? (
                  <input
                    type="text"
                    className="form-control checkValidate"
                    value={
                      this.state.leave_days1 == null
                        ? this.props.data.leave_days == 1 ||
                          this.props.data.leave_days == 0.5
                          ? this.state.halfDay
                          : parseFloat(this.props.data.leave_days)
                        : this.state.leave_days1 == 0 ||
                          this.state.leave_days1 == 1
                        ? this.state.halfDay
                        : this.state.leave_days1
                    }
                  ></input>
                ) : (
                  <input
                    type="text"
                    className="form-control"
                    value={this.props.data.leave_days}
                    disabled
                  />
                )}
              </div>
            </div>
            {this.state.data.user_id == this.state.user_info.user_id &&
            (this.state.startDate != ""
              ? moment.utc(this.state.startDate).format("YYYY-MM-DD") ==
                moment.utc(this.state.endDate).format("YYYY-MM-DD")
              : this.props.data.leave_start_date ==
                this.props.data.leave_end_date) ? (
              <div className="form-group">
                <div>
                  <label className="col-sm-4">
                    Leave Type<span className="text-danger">*</span>
                  </label>{" "}
                </div>
                <div
                  onChange={this.onChangeWork.bind(this)}
                  className="col-sm-8"
                >
                  <input
                    type="radio"
                    value={0.5}
                    checked={this.state.halfDay == 0.5}
                    name="work"
                  />{" "}
                  Half Day <br />
                  <input
                    type="radio"
                    value={1.0}
                    checked={this.state.halfDay == 1}
                    name="work"
                  />{" "}
                  Full Day
                </div>
              </div>
            ) : (
              ""
            )}
            {this.state.showRadio && (
              <div className="form-group">
                <div>
                  <label className="col-sm-4">
                    AM or PM<span className="text-danger">*</span>
                  </label>{" "}
                </div>
                <div
                  onChange={this.onChangeRadio.bind(this)}
                  className="col-sm-8"
                >
                  <input
                    type="radio"
                    value={"AM"}
                    checked={
                      this.state.halfTime && this.state.halfTime.trim() == "AM"
                    }
                    disabled={
                      this.state.data.user_id != this.state.user_info.user_id
                    }
                    name="halfDay"
                  />{" "}
                  AM <br />
                  <input
                    type="radio"
                    value={"PM"}
                    checked={
                      this.state.halfTime && this.state.halfTime.trim() == "PM"
                    }
                    disabled={
                      this.state.data.user_id != this.state.user_info.user_id
                    }
                    name="halfDay"
                  />{" "}
                  PM
                </div>
              </div>
            )}
            <div className="form-group">
              <div>
                <label className="col-sm-4">Reason</label>
              </div>
              <div className="col-sm-8">
                {this.state.data.user_id == this.state.user_info.user_id ? (
                  <textarea
                    name="reason"
                    id="reason"
                    cols="30"
                    rows="5"
                    className="form-control checkValidate"
                    value={
                      this.state.reason == ""
                        ? this.props.data.reason
                        : this.state.reason
                    }
                    onChange={this.handleChangeReason}
                  ></textarea>
                ) : (
                  <textarea
                    name="reason"
                    id="reason"
                    cols="30"
                    rows="5"
                    className="form-control"
                    value={this.props.data.reason}
                    disabled
                  ></textarea>
                )}
              </div>
            </div>
            {this.props.data.leave_category_id != 11 ? (
              this.props.data.user_id != this.state.user_info.user_id ? (
                <div className="form-group">
                  <div>
                    <label className="col-sm-4">Comments</label>
                  </div>
                  <div className="col-sm-8">
                    <textarea
                      name="comments"
                      id="comments"
                      cols="30"
                      rows="5"
                      className={
                        this.state.data.user_id == this.state.user_info.user_id
                          ? "form-control"
                          : "form-control checkValidate"
                      }
                      value={this.state.comments}
                      onChange={this.handleChangeComment}
                    ></textarea>
                  </div>
                </div>
              ) : (
                <div className="form-group">
                  <div>
                    <label className="col-sm-4">Comments</label>
                  </div>
                  <div className="col-sm-8">
                    <textarea
                      name="comments"
                      id="comments"
                      cols="30"
                      rows="5"
                      className={
                        this.state.data.user_id == this.state.user_info.user_id
                          ? "form-control"
                          : "form-control checkValidate"
                      }
                      value={this.props.data.comments}
                      // onChange={this.handleChangeComment}
                      disabled
                    ></textarea>
                  </div>
                </div>
              )
            ) : (
              ""
            )}
            {this.state.data.user_id == this.state.user_info.user_id ? (
              <div className="form-group">
                <div>
                  <label htmlFor="attachment" className="col-sm-4">
                    Attachment
                  </label>
                </div>
                <div className="col-sm-8">
                  <input
                    type="file"
                    className=""
                    id="attach_file"
                    onChange={this.checkFiles}
                  />
                </div>
                <div className="col-sm-8" style={{ marginTop: "10px" }}>
                  Attached file တွဲပါက HRMS စနစ်မှ attach file တစ်ခုသာ တွဲရန်
                  ကန့်သတ်ထားပါသဖြင့် attach တွဲမည့်ဖိုင်များကို PDF ဖိုင်ဖြင့်
                  ၁ဖိုင်တည်းပေါင်းပြီးမှသာ တွဲတင်ပေးပါရန်။
                </div>
              </div>
            ) : (
              ""
            )}

            {/* {this.state.doc !== [] && this.state.doc !== null ? ( */}
            {this.state.doc !== null && this.state.doc.length ? (
              <div className="row document-main">
                {this.state.data.user_id == this.state.user_info.user_id ? (
                  this.state.doc.length > 0 ? (
                    <>
                      <div className="col-md-4"></div>
                      <div className="fileuploader-items col-md-8">
                        <ul className="fileuploader-items-list">
                          <li className="fileuploader-item file-has-popup file-type-application file-ext-odt">
                            <div className="columns">
                              <div className="column-title">
                                <a
                                  href={`${main_url}leave/getCRDocumentData/${this.state.user_info.user_id}/${this.state.doc}`}
                                  download
                                  target="_blank"
                                  className="btn btn-primary document-body-bt document-width"
                                >
                                  {this.state.doc.split("&@")[1]}
                                </a>
                              </div>
                              <div className="column-actions">
                                <a
                                  className="fileuploader-action fileuploader-action-remove"
                                  onClick={(event) =>
                                    this.removeOldDocument(event)
                                  }
                                >
                                  {" "}
                                  <i></i>
                                </a>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </>
                  ) : (
                    ""
                  )
                ) : this.state.doc.length > 0 ? (
                  <div className="main-info">
                    <div className="header-info col-sm-12">
                      <h4>Leave Management</h4>
                    </div>
                    <a
                      href={`${main_url}leave/getCRDocumentData/${this.state.user_info.user_id}/${this.state.doc}`}
                      download
                      target="_blank"
                      className="btn btn-primary document-body-bt document-width"
                    >
                      {this.state.doc.split("&@")[1]}
                    </a>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="mt20">
            {this.props.data.leave_category_id == 11 ? (
              <div
                className="row"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <div className="col-sm-4 ">
                  {this.props.data.application_status == 8 ||
                  (this.props.data.application_status > 5
                    ? this.props.data.verify_date != null
                    : this.props.data.application_status != 1) ||
                  (this.props.data.verify_by == this.state.user_info.user_id) ==
                    false ||
                  (this.props.data.previous_status == 2 &&
                    this.props.data.application_status == 9) ? (
                    <button
                      className="btn btn-success"
                      style={{ fontSize: 11, cursor: "pointer" }}
                      onClick={() => this.verifySave()}
                      disabled
                    >
                      <span>
                        <i
                          class="far fa-thumbs-up"
                          style={{ paddingRight: "5px" }}
                        ></i>
                        Verified
                      </span>
                    </button>
                  ) : (
                    <button
                      className="btn btn-success"
                      style={{ fontSize: 11, cursor: "pointer" }}
                      onClick={() => this.verifySave()}
                    >
                      <span>
                        <i
                          class="far fa-thumbs-up"
                          style={{ paddingRight: "5px" }}
                        ></i>
                        Verified
                      </span>
                    </button>
                  )}
                </div>
                <div className="col-sm-4 " style={{ paddingRight: "20px" }}>
                  {(this.props.data.application_status > 5
                    ? this.props.data.previous_status == 1 ||
                      (this.props.data.previous_status == 3 &&
                        this.props.data.application_status == 9)
                    : this.props.data.application_status !== 2) ||
                  (this.props.data.approve_by ==
                    this.state.user_info.user_id) ==
                    false ? (
                    <button
                      className="btn btn-success"
                      style={{ fontSize: 11, cursor: "pointer" }}
                      onClick={() => this.approvedSave()}
                      disabled
                    >
                      <span>
                        <i
                          class="far fa-thumbs-up"
                          style={{ paddingRight: "5px" }}
                        ></i>
                        Approved
                      </span>
                    </button>
                  ) : (
                    <button
                      className="btn btn-success"
                      style={{ fontSize: 11, cursor: "pointer" }}
                      onClick={() => this.approvedSave()}
                    >
                      <span>
                        <i
                          class="far fa-thumbs-up"
                          style={{ paddingRight: "5px" }}
                        ></i>
                        Approved
                      </span>
                    </button>
                  )}
                </div>
              </div>
            ) : this.state.data.user_id == this.state.user_info.user_id ? (
              <div className="row">
                <div
                  className="col-4 btn-rightend"
                  style={{ paddingRight: "30px" }}
                >
                  {
                    <button
                      className="btn btn-success"
                      style={{ fontSize: 11, cursor: "pointer" }}
                      onClick={() => this.save()}
                    >
                      <span>
                        <i
                          class="far fa-thumbs-up"
                          style={{ paddingRight: "5px" }}
                        ></i>
                        Save
                      </span>
                    </button>
                  }
                </div>
              </div>
            ) : (
              <div
                className="row"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div className="col-sm-4 " style={{}}>
                  {this.props.data.application_status == 8 ||
                  (this.props.data.application_status == 1 &&
                    (this.props.data.verify_by ==
                      this.state.user_info.user_id) ==
                      false) ||
                  (this.props.data.application_status == 2 &&
                    (this.props.data.approve_by ==
                      this.state.user_info.user_id) ==
                      false) ||
                  this.props.data.application_status == 3 ||
                  (this.props.data.approved_date != null &&
                    this.props.data.application_status == 9) ||
                  this.props.data.application_status == 4 ||
                  this.props.data.application_status == 5 ||
                  (this.props.data.previous_status == 2 &&
                    (this.props.data.verify_by ==
                      this.state.user_info.user_id) ==
                      true &&
                    this.props.data.verify_by != this.props.data.approve_by) ? (
                    <button
                      className="btn"
                      style={{
                        fontSize: 11,
                        cursor: "pointer",
                        backgroundColor: "#cc0066",
                        color: "white",
                      }}
                      onClick={() => this.referBackSave()}
                      disabled
                    >
                      <span>
                        <i
                          class="fas fa-times"
                          style={{ paddingRight: "5px" }}
                        ></i>
                        Refer Back
                      </span>
                    </button>
                  ) : (
                    <button
                      className="btn"
                      style={{
                        fontSize: 11,
                        cursor: "pointer",
                        backgroundColor: "#cc0066",
                        color: "white",
                      }}
                      onClick={() => this.referBackSave()}
                    >
                      <span>
                        <i
                          class="fas fa-times"
                          style={{ paddingRight: "5px" }}
                        ></i>
                        Refer Back
                      </span>
                    </button>
                  )}
                </div>
                <div className="col-sm-4 ">
                  {this.props.data.application_status == 8 ||
                  (this.props.data.application_status > 5
                    ? this.props.data.verify_date != null
                    : this.props.data.application_status != 1) ||
                  (this.props.data.verify_by == this.state.user_info.user_id) ==
                    false ||
                  (this.props.data.previous_status == 2 &&
                    this.props.data.application_status == 9) ? (
                    <button
                      className="btn btn-success"
                      style={{ fontSize: 11, cursor: "pointer" }}
                      onClick={() => this.verifySave()}
                      disabled
                    >
                      <span>
                        <i
                          class="far fa-thumbs-up"
                          style={{ paddingRight: "5px" }}
                        ></i>
                        Verified
                      </span>
                    </button>
                  ) : (
                    <button
                      className="btn btn-success"
                      style={{ fontSize: 11, cursor: "pointer" }}
                      onClick={() => this.verifySave()}
                    >
                      <span>
                        <i
                          class="far fa-thumbs-up"
                          style={{ paddingRight: "5px" }}
                        ></i>
                        Verified
                      </span>
                    </button>
                  )}
                </div>
                <div className="col-sm-4 " style={{ paddingRight: "20px" }}>
                  {(this.props.data.application_status > 5
                    ? this.props.data.previous_status == 1 ||
                      (this.props.data.previous_status == 3 &&
                        this.props.data.application_status == 9)
                    : this.props.data.application_status !== 2) ||
                  (this.props.data.approve_by ==
                    this.state.user_info.user_id) ==
                    false ? (
                    <button
                      className="btn btn-success"
                      style={{ fontSize: 11, cursor: "pointer" }}
                      onClick={() => this.approvedSave()}
                      disabled
                    >
                      <span>
                        <i
                          class="far fa-thumbs-up"
                          style={{ paddingRight: "5px" }}
                        ></i>
                        Approved
                      </span>
                    </button>
                  ) : (
                    <button
                      className="btn btn-success"
                      style={{ fontSize: 11, cursor: "pointer" }}
                      onClick={() => this.approvedSave()}
                    >
                      <span>
                        <i
                          class="far fa-thumbs-up"
                          style={{ paddingRight: "5px" }}
                        ></i>
                        Approved
                      </span>
                    </button>
                  )}
                </div>
                <div className="col-sm-4 " style={{}}>
                  {this.props.data.application_status == 8 ||
                  (this.props.data.application_status == 1 &&
                    (this.props.data.verify_by ==
                      this.state.user_info.user_id) ==
                      false) ||
                  (this.props.data.application_status < 6
                    ? this.props.data.application_status == 3
                    : this.props.data.approved_date != null &&
                      this.props.data.application_status == 9) ||
                  this.props.data.application_status == 4 ||
                  this.props.data.application_status == 5 ||
                  (this.props.data.application_status == 2 &&
                    (this.props.data.approve_by ==
                      this.state.user_info.user_id) ==
                      false) ||
                  (this.props.data.previous_status == 2 &&
                    (this.props.data.verify_by ==
                      this.state.user_info.user_id) ==
                      true &&
                    this.props.data.verify_by != this.props.data.approve_by) ? (
                    <button
                      className="btn btn-danger"
                      style={{ fontSize: 11, cursor: "pointer" }}
                      onClick={() => this.rejectSave()}
                      disabled
                    >
                      <span>
                        <i
                          class="fas fa-times"
                          style={{ paddingRight: "5px" }}
                        ></i>
                        Reject
                      </span>
                    </button>
                  ) : (
                    <button
                      className="btn btn-danger"
                      style={{ fontSize: 11, cursor: "pointer" }}
                      onClick={() => this.rejectSave()}
                    >
                      <span>
                        <i
                          class="fas fa-times"
                          style={{ paddingRight: "5px" }}
                        ></i>
                        Reject
                      </span>
                    </button>
                  )}
                </div>
                <div className="col-sm-4 " style={{}}>
                  {(this.props.data.application_status == 3 ||
                    (this.props.data.approved_date != null &&
                      this.props.data.application_status == 9)) &&
                  this.state.user_info.user_id == this.state.data.approve_by &&
                  (this.props.data.leave_category_id == 1 ||
                    this.props.data.leave_category_id == 5) ? (
                    <button
                      className="btn btn-success"
                      style={{ fontSize: 11, cursor: "pointer" }}
                      onClick={() => this.approvedSave()}
                    >
                      <span>
                        <i
                          class="far fa-thumbs-up"
                          style={{ paddingRight: "5px" }}
                        ></i>
                        Edit
                      </span>
                    </button>
                  ) : (
                    <button
                      className="btn btn-success"
                      style={{ fontSize: 11, cursor: "pointer" }}
                      onClick={() => this.approvedSave()}
                      disabled
                    >
                      <span>
                        <i
                          class="far fa-thumbs-up"
                          style={{ paddingRight: "5px" }}
                        ></i>
                        Edit
                      </span>
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default LeaveManagementEdit;
